const P = 'teamManagement/';

export const FETCH_TEAMS = P + 'FETCH_TEAMS';
export const FETCH_TEAMS_SUCCESS = P + 'FETCH_TEAMS_SUCCESS';
export const FETCH_TEAMS_FAILURE = P + 'FETCH_TEAMS_FAILURE';

export const FETCH_TEAM_DETAIL = P + 'FETCH_TEAM_DETAIL';
export const FETCH_TEAM_DETAIL_SUCCESS = P + 'FETCH_TEAM_DETAIL_SUCCESS';
export const FETCH_TEAM_DETAIL_FAILURE = P + 'FETCH_TEAM_DETAIL_FAILURE';
export const CLEAR_TEAM_DETAIL = P + 'CLEAR_TEAM_DETAIL';

export const CREATE_TEAM = P + 'CREATE_TEAM';
export const CREATE_TEAM_SUCCESS = P + 'CREATE_TEAM_SUCCESS';
export const CREATE_TEAM_FAILURE = P + 'CREATE_TEAM_FAILURE';

export const UPDATE_TEAM = P + 'UPDATE_TEAM';
export const UPDATE_TEAM_SUCCESS = P + 'UPDATE_TEAM_SUCCESS';
export const UPDATE_TEAM_FAILURE = P + 'UPDATE_TEAM_FAILURE';

export const DELETE_TEAM = P + 'DELETE_TEAM';
export const DELETE_TEAM_SUCCESS = P + 'DELETE_TEAM_SUCCESS';
export const DELETE_TEAM_FAILURE = P + 'DELETE_TEAM_FAILURE';

export const ADD_MEMBER = P + 'ADD_MEMBER';
export const ADD_MEMBER_SUCCESS = P + 'ADD_MEMBER_SUCCESS';
export const UPDATE_MEMBER = P + 'UPDATE_MEMBER';
export const UPDATE_MEMBER_SUCCESS = P + 'UPDATE_MEMBER_SUCCESS';
export const REMOVE_MEMBER = P + 'REMOVE_MEMBER';
export const REMOVE_MEMBER_SUCCESS = P + 'REMOVE_MEMBER_SUCCESS';

// Created entity navigation
export const CLEAR_LAST_CREATED_TEAM = P + 'CLEAR_LAST_CREATED_TEAM';

export const OPEN_TEAM_DIALOG = P + 'OPEN_TEAM_DIALOG';
export const CLOSE_TEAM_DIALOG = P + 'CLOSE_TEAM_DIALOG';
export const OPEN_DELETE_DIALOG = P + 'OPEN_DELETE_DIALOG';
export const CLOSE_DELETE_DIALOG = P + 'CLOSE_DELETE_DIALOG';
export const OPEN_DETAIL_DIALOG = P + 'OPEN_DETAIL_DIALOG';
export const CLOSE_DETAIL_DIALOG = P + 'CLOSE_DETAIL_DIALOG';

export const SET_FILTERS = P + 'SET_FILTERS';
export const SET_PAGINATION = P + 'SET_PAGINATION';
export const SET_SORT = P + 'SET_SORT';

// Dropdown options
export const FETCH_EMPLOYEE_OPTIONS = P + 'FETCH_EMPLOYEE_OPTIONS';
export const FETCH_EMPLOYEE_OPTIONS_SUCCESS = P + 'FETCH_EMPLOYEE_OPTIONS_SUCCESS';
export const FETCH_EMPLOYEE_OPTIONS_FAILURE = P + 'FETCH_EMPLOYEE_OPTIONS_FAILURE';
